import { z } from 'zod';

export const animationV0Schema = z.object({
    version: z.literal(0),
    isActive: z.boolean(),
    animationType: z.enum(['fade', 'slide', 'scale']),
    animationPosition: z.enum(['left', 'top', 'right', 'bottom', 'center']),
    animationSpeed: z.enum(['slow', 'medium', 'fast']),
});
